module.exports = __webpack_public_path__ + "static/media/eth.42bca731.svg";